// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"fbf723ce","421":"8129fba4","501":"6f746b84","668":"09e82167","787":"e80b65c1"}[chunkId] + ".chunk.js";
};